/**
 * Haptic feedback utility for mobile interactions.
 * Uses the Vibration API where available (Android Chrome, etc.).
 * Silently no-ops on iOS Safari and desktop browsers.
 */

/** Light tap — tab click, button press */
export function hapticLight() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(15);
  }
}

/** Medium tap — page swipe navigation */
export function hapticMedium() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(30);
  }
}

/** Success feedback — form submit, action complete */
export function hapticSuccess() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([20, 50, 20]);
  }
}
